import {
  Popover as KobaltePopover,
  type PopoverContentProps,
  type PopoverRootProps,
} from "@kobalte/core/popover";
import { type JSX, splitProps } from "solid-js";
import { cn } from "@bso/shared";

export function Popover(props: PopoverRootProps) {
  // gutter: separación con el trigger. Por defecto la dejamos pequeña y sutil.
  return <KobaltePopover gutter={6} {...props} />;
}

export const PopoverTrigger = KobaltePopover.Trigger;

interface PopoverContentLocalProps extends PopoverContentProps {
  class?: string;
  children?: JSX.Element;
}

export function PopoverContent(props: PopoverContentLocalProps) {
  const [local, others] = splitProps(props, ["class", "children"]);

  return (
    <KobaltePopover.Portal>
      <KobaltePopover.Content
        class={cn(
          "z-[220] rounded-xl border border-border bg-card text-foreground shadow-2xl outline-none",
          "origin-[var(--kb-popover-content-transform-origin)]",
          local.class,
        )}
        {...others}
      >
        {local.children}
      </KobaltePopover.Content>
    </KobaltePopover.Portal>
  );
}
